import { Component, inject } from '@angular/core';
import { BaseListComponent } from '../base-list/base-list.component';
import { MenuItem, MessageService, PrimeTemplate } from 'primeng/api';
import { SidebarService } from '../../../services/menu/sidebar.service';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { ConfirmationDialogService } from '../../../services/confirmation-dialog.service';
import { RoutingService } from '../../../services/routing.service';
import { Tokens } from 'marked';
import Tag = Tokens.Tag;
import { TagStore } from '../../../stores/tag/tag.state';
import { HeaderComponent } from '../../atoms/header/header.component';
import { MaskComponent } from '../mask/mask.component';
import { NgIf } from '@angular/common';
import { SidebarModule } from 'primeng/sidebar';
import { TableCaptionComponent } from '../../molecules/table-list-caption/table-list-caption.component';
import { TableListActionsComponent } from '../../molecules/table-list-actions/table-list-actions.component';
import { TableModule } from 'primeng/table';
import { TagListComponent } from '../../molecules/tag-list/tag-list.component';

@Component({
  selector: 'app-tag-administration',
  standalone: true,
  imports: [
    HeaderComponent,
    MaskComponent,
    NgIf,
    PrimeTemplate,
    RouterOutlet,
    SidebarModule,
    TableCaptionComponent,
    TableListActionsComponent,
    TableModule,
    TagListComponent,
  ],
  templateUrl: './tag-administration.component.html',
  styleUrl: './tag-administration.component.scss',
})
export class TagAdministrationComponent extends BaseListComponent<Tag> {
  readonly store = inject(TagStore);
  override menuItems: MenuItem[] = [];
  override sidebarId = 'tag-administration';

  constructor(
    protected sidebarService: SidebarService,
    router: Router,
    route: ActivatedRoute,
    messageService: MessageService,
    confirmationDialogService: ConfirmationDialogService,
    routingService: RoutingService
  ) {
    super(
      router,
      route,
      messageService,
      confirmationDialogService,
      routingService
    );
  }
}
